<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="单位编码" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="portalOrgCode">
              <a-input v-model="model.portalOrgCode" placeholder="请输入单位编码"></a-input><!-- maxLength=50 -->
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="单位名称" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="portalOrgName">
              <a-input v-model="model.portalOrgName" placeholder="请输入单位名称"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="单位简介" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="portalOrgDesc">
              <a-textarea v-model="model.portalOrgDesc" placeholder="请输入单位简介"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="单位状态" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="status">
              <j-dict-select-tag type="radio" v-model="model.status" :trigger-change="true" dictCode="sys_portal_up_down" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="顺序" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="sortNo">
              <a-input-number v-model="model.sortNo" placeholder="请输入顺序" style="width: 100%" :min="1" :max="999999"/>
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item label="应用分配" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-multi-select-tag
                v-model="model.selectedApps"
                :options="appsOptions"
                placeholder="请选择应用">
              </j-multi-select-tag>
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
              <a-textarea placeholder="请输入备注" v-model="model.remark" :maxLength="ml" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'

  export default {
    name: 'SysPortalOrgForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{},
        ml:1000,
        appsOptions:[],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          portalOrgCode: [
            { required: true, message: '请输入单位编码!'},
            {validator: this.validateOrgCode,}
           ],
          portalOrgName: [
            { required: true, message: '请输入单位名称!'},
            {validator: this.validateOrgName,}
           ],
          portalOrgDesc: [
              { required: true, message: '请输入单位简介!'},
           ],
          status: [
              { required: true, message: '请选择单位状态!'},
           ],
        },
        url: {
          add: "/sys/portal/sysPortalOrg/add",
          edit: "/sys/portal/sysPortalOrg/edit",
          queryById: "/sys/portal/sysPortalOrg/queryById",
          doDuplicateCheck:"/sys/portal/sysPortalOrg/doDuplicateCheck",
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.initAppList();
        let that = this;
        this.model = Object.assign({},{selectedApps:''}, record);
        this.visible = true;
        // setTimeout(()=>{
          if(record.hasOwnProperty("id")){
            that.getPortalApps(record.id);
          }
        // },1500)
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },

      validateOrgCode(rule, value, callback){
        let params = {
          portalOrgName: value,
          id:this.model.id
        };
        getAction(this.url.doDuplicateCheck,params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback("公司编码已存在!")
          }
        })
      },
      validateOrgName(rule, value, callback){
        let params = {
          portalOrgCode: value,
          id:this.model.id

        };
        getAction(this.url.doDuplicateCheck,params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback("公司名称已存在!")
          }
        })
      },

      //初始化应用list
      initAppList(){
        getAction("/sys/portal/sysPortalOrg/getAllApps").then((res)=>{
          if(res.success){
            this.appsOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.applicationName, value:item.id}
              return c;
            })
            console.log('this.appsOptions: ',this.appsOptions)
          }
        })
      },

      getPortalApps(portalOrgId){
        getAction("/sys/portal/sysPortalOrg/getPortalApps",{id:portalOrgId}).then((res)=>{
          if(res.success){
            this.model.selectedApps = res.result.join(",");
            console.log('that.model.selectedApps=',this.model.selectedApps)
          }
        })
      },

    }
  }
</script>